import React from 'react'
import { getHot, getThink } from 'services/api/search'
import debounce from 'lodash/debounce'
import { inject, observer } from 'mobx-react'
import * as styles from './index.scss'

interface Props {
  onSearch?: (value: string) => any
  searchStore?: any
}

@inject('searchStore')
@observer
class SearchBar extends React.Component<Props, any> {
  private inputer: HTMLInputElement

  constructor(props) {
    super(props)
    this.state = {
      showHot: false,
      showThink: false,
      hotkeys: [],
      historykeys: [],
      thinkkeys: [],
    }

    this.getThinks = debounce(this.getThinks.bind(this), 200)
  }

  componentDidMount() {
    getHot().then(({ SearchRecord, SearchHistory }) => {
      const hotkeys = SearchRecord.map(({ search_content }) =>
        search_content.trim(),
      )
      const historykeys = SearchHistory.map(({ search_content }) =>
        search_content.trim(),
      )
      this.setState({ hotkeys, historykeys })
    })
    document.querySelector('body').addEventListener('click', this.handleEvent)
  }

  componentWillUnmount() {
    document
      .querySelector('body')
      .removeEventListener('click', this.handleEvent)
  }

  handleEvent = e => {
    if (e.target !== this.inputer) {
      if (e.target.tagName === 'SPAN') {
        return
      }
      this.cancelHot()
    }
  }

  get searchKey() {
    if (location.href.includes('searchresult')) {
      return this.props.searchStore.searchKeyWords
    }
  }

  getThinks() {
    if (!this.inputer.value.length) {
      return
    }
    const { data } = getThink(this.inputer.value)
    this.setState({
      thinkkeys: data.map(({ title }) => title.trim()),
    })
  }

  handleFocus = e => {
    const len = e.target ? !!e.target.value.length : false
    this.inputer.placeholder = ''
    this.setState({
      showHot: !len,
      showThink: len,
    })
  }
  handleBlur = () => {
    this.inputer.placeholder = this.searchKey || '请输入关键词'
  }
  handleChange = e => {
    const len = e.target ? !!e.target.value.length : false
    this.setState({
      showHot: !len,
      showThink: len,
    })
    if (e.target && e.target.value.trim().length) {
      this.getThinks()
    }
  }
  onEnter = () => this.handleSearch(this.inputer.value)
  cancelHot = () => this.setState({ showHot: false, showThink: false })
  handleKey = e => {
    if (e.keyCode === 13) {
      return this.handleSearch(e.target.value)
    }
  }
  handleSearch = val => {
    const { onSearch } = this.props
    this.setState({ showHot: false, showThink: false })
    this.inputer.blur()
    this.inputer.value = ''
    return onSearch && onSearch(val)
  }

  render() {
    const { showHot, showThink } = this.state

    const splitKey = (key: string, word: string) => {
      return [key, word.split(key)[1]].map((item, idx) => (
        <span
          key={`tk${key}${idx}`}
          className={styles.searchthinkKey}
          style={{
            fontWeight: !idx ? 600 : 400,
          }}
        >
          {item}
          {!idx && ' '}
        </span>
      ))
    }

    const hotframe = (xkeys?, ykeys?) => (
      <div
        className={styles.searchhot}
        style={{ display: showHot ? 'block' : 'none' }}
      >
        <div className={styles.searchhotInner}>
          <span className={styles.searchhotTitle}>历史搜索</span>
          {xkeys &&
            xkeys.map((v, i) => (
              <span
                key={`key${i}`}
                onClick={() => this.handleSearch(v)}
                className={styles.searchhotKey}
              >
                {v}
              </span>
            ))}
          <span className={styles.searchhotTitle} style={{ marginTop: 8 }}>
            热搜关键词
          </span>
          {ykeys &&
            ykeys.map((v, i) => (
              <span
                key={`key${i}`}
                onClick={() => this.handleSearch(v)}
                className={styles.searchhotKey}
              >
                {v}
              </span>
            ))}
        </div>
      </div>
    )

    const thinkframe = word => (
      <div
        className={styles.searchthink}
        style={{ display: showThink ? 'block' : 'none' }}
      >
        <div className={styles.searchhotInner}>
          {this.state.thinkkeys.map((item, idx) =>
            splitKey(word, item).length ? (
              <span
                key={`th${idx}`}
                onClick={() => this.handleSearch(item)}
                className={styles.searchthinkItem}
              >
                {splitKey(word, item)}
              </span>
            ) : null,
          )}
        </div>
      </div>
    )

    const SearchBody = (
      <div className={styles.searchbarBody}>
        <input
          ref={node => (this.inputer = node)}
          type="text"
          placeholder={this.searchKey || '请输入关键词'}
          className={styles.searchbarInput}
          onKeyDown={this.handleKey}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
        />
        <button className={styles.searchbarButton} onClick={this.onEnter}>
          搜 索
        </button>
        {hotframe(this.state.historykeys, this.state.hotkeys)}
        {thinkframe(this.state.showThink ? this.inputer.value : '')}
      </div>
    )

    return <div className={styles.searchbar}>{SearchBody}</div>
  }
}

export default SearchBar
